import { useEffect, useRef, useState } from 'react';
import '../App.css';
import { Link, useLocation } from 'react-router-dom';

const Navbar = ({toolbarinfo, resumeInfo}) => {
  const [navtop, setNavtop] = useState(0)
  const [navpos, setNavpos] = useState("fixed")
  const [path, setPath] = useState("")
  const lastscrollpos = useRef(0)
  const thisref = useRef(null)
  const location = useLocation()
  
  useEffect(() => {
    console.log("location")
    console.log(location.pathname)
    setPath(location.pathname)
  }, [location])


  useEffect(() => {
      const handleScroll = (event) => {
        const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        let { top, height } = thisref.current.getBoundingClientRect()
        if(currentScrollPosition - lastscrollpos.current > 5){
          setNavtop(-height)
 
        }
        if(currentScrollPosition - lastscrollpos.current < -5){
          setNavtop(0)
        }

        lastscrollpos.current = currentScrollPosition
      }

      window.addEventListener('scroll', handleScroll);

      return () => {
        window.removeEventListener('scroll', handleScroll);
      };

    }, [setNavpos, setNavtop]
  )

  return(
    <>
      {(toolbarinfo.length !== 0 ) && 
        <>
          <header className='App-header'/>
          <header className='App-header App-header-color' ref={thisref} style={{position: navpos, top: navtop}}>
            <span className='App-header-title'>
              <h2 className='new-title'>Marc Sharrer</h2>
            </span>
            <ol className='App-header-side'>
              <li className='nav-button'><Link to='/' style={{color: path === '/' ? "red" : "black"}}>HOME</Link></li>
              <li className='nav-button'><Link to='/about' style={{color: path === '/about' ? "red" : "black"}}>ABOUT</Link></li>
            </ol>
          </header>
        </>
      }
      </>
  )

}

export default Navbar;